import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { NavigationContainer } from "@react-navigation/native";
import LoginScreen from "./screens/LoginScreen";
import SignUpScreen from "./screens/SignUpScreen";
import HomeScreen from "./screens/HomeScreen";
import MedicalScreen from "./screens/MedicalScreen";
import AddIdentityScreen from "./screens/AddIdentityScreen";
import QrScreen from "./screens/QrScreen";
import { Provider } from "react-redux";
import store from "./store/store.js";
import IdentityScreen from "./screens/IdentityScreen";

export type RootStackParamList = {
  Login: undefined;
  Home: undefined;
  Medical: undefined;
  SignUp: undefined;
  Identity: undefined;
  Qr: undefined;
  AllIdentity: undefined;
};

export default function RootNavigation() {
  // const store = configureStore();

  const Stack = createStackNavigator<RootStackParamList>();

  const screenOptions = {
    headerShown: false,
  };

  return (
    <Provider store={store}>
      <NavigationContainer>
        <Stack.Navigator initialRouteName="Login" screenOptions={screenOptions}>
          <Stack.Screen name="Login" component={LoginScreen} />
          <Stack.Screen name="SignUp" component={SignUpScreen} />
          <Stack.Screen name="Identity" component={AddIdentityScreen} />
          <Stack.Screen name="Home" component={HomeScreen} />
          <Stack.Screen name="Medical" component={MedicalScreen} />
          <Stack.Screen name="AllIdentity" component={IdentityScreen} />
          <Stack.Screen name="Qr" component={QrScreen} />
        </Stack.Navigator>
      </NavigationContainer>
    </Provider>
  );
}
